import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12 4.5a2.5 2.5 0 0 0-4.96-.46 2.5 2.5 0 0 0-1.98 3 2.5 2.5 0 0 0-1.32 4.24 3 3 0 0 0 .34 5.58 2.5 2.5 0 0 0 2.96 3.08A2.5 2.5 0 0 0 9.5 22c1.21 0 2.5-.74 2.5-2.5m0-15a2.5 2.5 0 0 1 4.96-.46 2.5 2.5 0 0 1 1.98 3 2.5 2.5 0 0 1 1.32 4.24 3 3 0 0 1-.34 5.58 2.5 2.5 0 0 1-2.96 3.08A2.5 2.5 0 0 1 14.5 22c-1.21 0-2.5-.74-2.5-2.5m0-15V5m0 14.5V19",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 9v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 14v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14.6 10.5-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m10.27 13-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14.6 13.5-.87-.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m10.27 11-.87-.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BrainCog";
const BrainCog = memo(themed(Icon));
export {
  BrainCog
};
//# sourceMappingURL=brain-cog.js.map
